import "./index.scss";

// Utility to format date as MM/DD/YYYY
const getNextWeekDate = () => {
  const date = new Date();
  date.setDate(date.getDate() + 7);
  return date.toLocaleDateString("en-US");
};

export default function Summary({ lead }) {
  const defaultSummaryData = {
    quoteNumber: lead?.quoteNumber || "N/A",
    defendant: `${lead?.personalInfo?.["First Name"] || "N/A"} ${
      lead?.personalInfo?.["Last Name"] || ""
    }`.trim(),
    debt: lead?.amountInfo?.Amount || "N/A",
    state: lead?.lawsuitDetails?.["State the lawsuit was filed in"] || "N/A",
    plaintiff: lead?.lawsuitDetails?.["creditor (plaintiff)"] || "N/A",
    quoteExpiration: getNextWeekDate(),
    defendantType: lead?.identity === "PERSONAL" ? "Personal" : "Company",
  };

  const {
    quoteNumber,
    defendant,
    debt,
    state,
    plaintiff,
    quoteExpiration,
    defendantType,
  } = defaultSummaryData;

  return (
    <div className="quote-summary__details">
      <div className="quote-summary__details__column">
        <p>
          <strong>Quote #</strong> {quoteNumber}
        </p>
        <p>
          <strong>Defendant:</strong> {defendant}
        </p>
        <p>
          <strong>Debt:</strong> ${debt}
        </p>
      </div>

      <div className="quote-summary__details__column">
        <p>
          <strong>State:</strong> {state}
        </p>
        {/* <p>
            <strong>Case #:</strong> {caseNumber}
          </p> */}
        <p>
          <strong>Plaintiff:</strong> {plaintiff}
        </p>
      </div>

      <div className="quote-summary__details__column">
        <p>
          <strong>Quote Expiration:</strong> {quoteExpiration}
        </p>
        <p>
          <strong>Defendant Type:</strong> {defendantType}
        </p>
      </div>
    </div>
  );
}
